// extracted by mini-css-extract-plugin
module.exports = {"fleetImg":"fleet-about-module--fleetImg--1QAxA","fleetText":"fleet-about-module--fleetText--2nmBQ","fleetLink":"fleet-about-module--fleetLink--19iOA"};